@if (loading) {
<p-skeleton width="7rem" height="2.25rem" styleClass="my-1 mx-auto" />
} @else {
<div class="card flex justify-content-center iese-button-group" [bdcWalkTriggerFor]="popupStepSelectOrigin">
  <button
    class="button"
    type="button"
    [class.active]="value === DataOrigin.REPOSITORY"
    (click)="select(DataOrigin.REPOSITORY)"
    pTooltip="Use the IESE repository and the Internet as your knowledge base."
    tooltipPosition="top"
  >
    <svg repositoryOrigin styleClass="file-icon-medium"></svg>
  </button>
  <button
    class="button"
    type="button"
    [bdcWalkTriggerFor]="popupStepOwnFiles"
    [class.active]="value === DataOrigin.FILES"
    pBadge
    [badgeDisabled]="!hasActiveChatFiles"
    (click)="select(DataOrigin.FILES)"
    pTooltip="Use your own files and the Internet as your knowledge base."
    tooltipPosition="top"
  >
    <svg filesOrigin styleClass="file-icon-medium"></svg>
  </button>
  <button
    class="button"
    type="button"
    [class.active]="value === DataOrigin.NONE"
    (click)="select(DataOrigin.NONE)"
    pTooltip="Use only the Internet as your knowledge base."
    tooltipPosition="top"
  >
    <svg noneOrigin styleClass="file-icon-medium"></svg>
  </button>
</div>

<bdc-walk-popup
  sideNoteText="8/13"
  [showCloseButton]="false"
  #popupStepOwnFiles
  name="popupStepOwnFiles"
  header="Upload your own files"
  xPosition="after"
  yPosition="above"
  [showButton]="true"
  buttonText="Next"
  [mustCompleted]="{ popupStep9: true }"
  class="warning"
>
  <div>
    You can now upload your own documents (PDF, Word, PowerPoint) by clicking the paperclip icon or dragging them into
    the chat. MyAI will use only the content from these files to answer your queries.
  </div>
  <div class="buttons-skip">
    <button
      class="iese-button iese-button-skip"
      (click)="this.bdcWalkService.setTaskCompleted('popupStep9', false)"
      mat-raised-button
      color="primary"
    >
      Previous
    </button>
    <button class="iese-button iese-button-skip" (click)="endOnboardingTour()" mat-raised-button color="primary">
      Skip
    </button>
  </div>
</bdc-walk-popup>

<bdc-walk-popup
  sideNoteText="9/13"
  [showCloseButton]="false"
  #popupStepSelectOrigin
  name="popupStepSelectOrigin"
  header="Select your knowledge base"
  xPosition="after"
  yPosition="above"
  [showButton]="true"
  buttonText="Next"
  [mustCompleted]="{ popupStepOwnFiles: true }"
  class="warning"
>
  <div>
    Click on one of the icons above the message box to decide which source MyAI should use: Public data only
    <svg style="height: 16px" noneOrigin styleClass="file-icon-medium"></svg> | IESE Repository knowledge base
    <svg style="height: 16px" repositoryOrigin styleClass="file-icon-medium"></svg> | Your uploaded files
    <svg style="height: 16px" filesOrigin styleClass="file-icon-medium"></svg>. This gives you full control over the
    information used to answer your questions.
  </div>
  <div class="buttons-skip">
    <button
      class="iese-button iese-button-skip"
      (click)="this.bdcWalkService.setTaskCompleted('popupStepOwnFiles', false)"
      mat-raised-button
      color="primary"
    >
      Previous
    </button>
    <button class="iese-button iese-button-skip" (click)="endOnboardingTour()" mat-raised-button color="primary">
      Skip
    </button>
  </div>
</bdc-walk-popup>

<bdc-walk-dialog #popupStepCombineOrigin name="popupStepCombineOrigin" width="650px" [mustCompleted]="{ popupStepSelectOrigin: true }">
  <div class="mat-dialog-iese">
    <h1 class="header">Combine sources freely</h1>
    You’re not limited to one source. You can start using your own files, then switch to IESE content, or use only the
    model with no added context. Just click the icons anytime to switch.

    <div class="buttons-skip">
      <button
        class="iese-button iese-button-skip"
        (click)="this.bdcWalkService.setTaskCompleted('popupStepSelectOrigin', false)"
        mat-raised-button
        color="primary"
      >
        Previous
      </button>
      <button class="iese-button iese-button-skip" (click)="endOnboardingTour()" mat-raised-button color="primary">
        Skip
      </button>
    </div>
    <div class="buttons">
      <div class="sideNote">10/13</div>
      <button class="iese-button primary" (click)="popupStepCombineOrigin.close()" mat-raised-button color="primary">Next</button>
    </div>
  </div>
</bdc-walk-dialog>
}
